import React from 'react';

const LogoFull = () => {
  return (
    <div>
      <img
        src="/thaleslogo-white.png"
        alt="Thales Group"
        style={{
          width: 'auto',
          height: 70,
        }}
      />
    </div>
  );
};

export default LogoFull;
